module.exports = __webpack_public_path__ + "img/accordian_down_arrow.e83d33d7.svg";